var React = require('react');

function CollapseIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11 10a1 1 0 0 0-1 1v10a1 1 0 1 0 2 0V11a1 1 0 0 0-1-1zm6.414 6 4.293-4.293a1 1 0 1 0-1.414-1.414l-5 5-.707.707.707.707 5 5a1 1 0 1 0 1.414-1.414L17.414 16z","fill":"#D9D9D9"}));
}

CollapseIcon.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = CollapseIcon;

CollapseIcon.default = CollapseIcon;
